import DataRequest from '@get-bridge/learn-legacy-shared/dist/core/DataRequest';
import UserPayload from '../schemas/UserPayload';
import ajax from '@get-bridge/learn-legacy-shared/dist/utils/ajax';
import parseUser from 'parseUser';

export default DataRequest({
  schema: UserPayload,

  perform({ managerId, params }) {
    return ajax({
      url: `/api/private/users/${managerId}/direct_reports`,
      data: params,
    });
  },

  parse(normalize, payload) {
    return {
      manager: payload.manager && parseUser(normalize(payload.manager)),
      directReports: payload.direct_reports.map(normalize).map(parseUser)};
  },
});



// WEBPACK FOOTER //
// ./packages/bridge-global-nav/src/users/data_requests/getDirectReports.js